/** 是否为 HTML 响应（常见于 /api 未反代、被 SPA try_files 回落到 index.html） */
export function isHtmlApiResponse(response) {
  const contentType = response?.headers?.['content-type'] || ''
  if (contentType.includes('text/html')) return true
  const data = response?.data
  if (typeof data === 'string' && data.includes('<!doctype html')) return true
  return false
}

/** 从后端统一错误体或网络异常中提取可读提示 */
export function extractApiError(error, fallback = '请求失败，请稍后重试') {
  const message = error?.response?.data?.message
  if (typeof message === 'string' && message.trim()) {
    return message.trim()
  }
  if (error?.code === 'ECONNABORTED') {
    return '请求超时，请检查网络'
  }
  const localMessage = typeof error?.message === 'string' ? error.message.trim() : ''
  if (localMessage && localMessage !== 'Network Error') {
    return localMessage
  }
  if (!error?.response) {
    return '无法连接服务器，请检查网络或代理配置'
  }
  return fallback
}

/** 是否为公开认证接口（不得携带旧 JWT） */
export function isPublicAuthPath(url) {
  if (!url) return false
  const path = url.split('?')[0]
  return path === '/auth/login' || path === '/auth/captcha' || path.startsWith('/auth/captcha/')
}
